module.exports = __webpack_public_path__ + "img/lange_crub_2.4c65dab5.jpg";